// extracted by mini-css-extract-plugin
module.exports = {"appWrapper":"AppWrapper_appWrapper__ZjBt1"};